export class CustomerAddress {
    public customerId: number = 0;
    public shipToId:string;
    public shipToName: string;
    public isMainAdress: boolean;
    public careOfName: string;
    public address1: string;
    public address2: string;
    public address3: string;
    public city: string;
    public postalCodeZip: string;
    public state: string;
    public country: string;
    public minimumAmountForFreeTransportFee: number = 0;
    public transportFeeAmount: number = 0;
    public freeTransportFeeAmount: number = 0;
    public compteDeCollecte: string = ''; // user19
    public orderDisposition: string = '';  // orderdisp
    public shipVia: string = ''; // shipviaty

    constructor(
        customerId:number = 0,
        shipToId:string = '',
        shipToName:string = '',
        isMainAdress:boolean = false,
        careOfName:string = '',
        address1:string = '',
        address2:string = '',
        address3:string = '',
        city:string = '',
        postalCodeZip:string = '',
        state:string = '',
        country:string = '',
        minimumAmountForFreeTransportFee: number = 0,
        transportFeeAmount: number = 0,
        freeTransportFeeAmount: number = 0,
        compteDeCollecte: string = '',
        orderDisposition: string = '',
        shipVia: string = ''
    ) {
        this.customerId = customerId;
        this.shipToId = shipToId;
        this.shipToName = shipToName;
        this.isMainAdress = isMainAdress;
        this.careOfName = careOfName;
        this.address1 = address1;
        this.address2 = address2;
        this.address3 = address3;
        this.city = city;
        this.postalCodeZip = postalCodeZip;
        this.state = state;
        this.country = country;
        this.minimumAmountForFreeTransportFee = minimumAmountForFreeTransportFee;
        this.transportFeeAmount = transportFeeAmount;
        this.freeTransportFeeAmount = freeTransportFeeAmount;
        this.compteDeCollecte = compteDeCollecte;
        this.orderDisposition = orderDisposition;
        this.shipVia = shipVia;
    }
}
